<div
  class="notification block"
  [ngClass]="notificationStyle()"
  [class.compact-mode]="scale() === NotificationScale.SMALL"
>
  @if (layout() === NotificationLayout.EDGE_TO_EDGE && !excludeColumns()) {
    <div class="grid-max-width grid-col-12">
      <div class="col-1-12">
        <ng-container *ngTemplateOutlet="wrappedContentTpl" />
      </div>
    </div>
  } @else {
    <ng-container *ngTemplateOutlet="wrappedContentTpl" />
  }
</div>

<ng-template #wrappedContentTpl>
  <div class="flex flex--start" [ngClass]="wrapperStyle()">
    @if (displayedIcon()) {
      <fcom-icon
        data-testid="notification-icon"
        class="message-type ms-xsmall-r flex--nogrow"
        [ngClass]="[sizes().iconSize, iconColorClass()]"
        [category]="iconCategory()"
        [name]="displayedIcon()"
      />
    }

    <div class="flex flex-1" [ngClass]="textContainerStyle()">
      <div class="ps-xsmall-r flex--self-start">
        @if (title()) {
          <span class="bold-type block ms-xsmall-b" [ngClass]="sizes().font.header" data-testid="notification-title">{{
            title()
          }}</span>
        }
        <ng-content />
      </div>
      @if (linkText()) {
        @if (linkUrl()) {
          <div>
            <fcom-link
              class="ms-xsmall-r flex--self-start"
              data-testid="notification-primary-link"
              [size]="sizes().linkSize"
              [href]="linkUrl()"
              [openInNewTab]="linkOpenInNewWindow()"
              [external]="linkOpenInNewWindow()"
              (beforeNavigation)="linkClick.emit($event)"
              >{{ linkText() }}</fcom-link
            >

            @if (secondaryLinkUrl() && secondaryLinkText()) {
              <fcom-link
                class="ms-xsmall-r flex--self-start"
                data-testid="notification-secondary-link"
                [size]="sizes().linkSize"
                [href]="secondaryLinkUrl()"
                [openInNewTab]="secondaryLinkOpenInNewWindow()"
                [external]="secondaryLinkOpenInNewWindow()"
                (beforeNavigation)="secondaryLinkClick.emit($event)"
              >
                {{ secondaryLinkText() }}
              </fcom-link>
            }
          </div>
        } @else {
          <div [ngClass]="{ 'flex--self-end': buttonStyle() !== NotificationButtonStyle.LINK }">
            <ng-container
              *ngTemplateOutlet="buttonStyle() === NotificationButtonStyle.LINK ? linkButtons : ctaButtons"
            />
          </div>
        }
      }
    </div>
    @if (isLoading()) {
      <fcom-loader [loaderType]="LoaderTheme.INLINE_TEXT" />
    }

    @if (isClosable() && !isLoading()) {
      <div class="close-button-wrapper">
        <fcom-icon-button
          [icon]="closeIcon()"
          [aria]="{ label: i18n().closeAriaLabel | finLocalization }"
          [size]="IconButtonSize.SMALL"
          [theme]="
            theme() === NotificationTheme.CAMPAIGN
              ? IconButtonTheme.DARK_TERTIARY_GHOST
              : IconButtonTheme.LIGHT_TERTIARY_GHOST
          "
          (clickBtn)="closeClick.emit($event)"
          data-testid="close-button"
        />
      </div>
    }
  </div>
</ng-template>

<ng-template #ctaButtons>
  @if (secondaryLinkText() && !secondaryLinkUrl()) {
    <fcom-button
      data-testid="notification-secondary-button"
      [text]="secondaryLinkText()"
      [theme]="
        theme() === NotificationTheme.CAMPAIGN ? ButtonTheme.DARK_TERTIARY_GHOST : ButtonTheme.LIGHT_TERTIARY_GHOST
      "
      (click)="secondaryLinkClick.emit($event)"
    />
  }

  <fcom-button
    class="ms-small-l"
    data-testid="notification-primary-button"
    [text]="linkText()"
    [theme]="
      theme() === NotificationTheme.CAMPAIGN
        ? ButtonTheme.DARK_PRIMARY_NORDIC_BLUE
        : ButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE
    "
    (click)="linkClick.emit($event)"
  />
</ng-template>

<ng-template #linkButtons>
  @if (secondaryLinkText()) {
    <fcom-link class="ms-xsmall-r flex--self-start" (afterNavigation)="secondaryLinkClick.emit($event)">
      {{ secondaryLinkText() }}
    </fcom-link>
  }

  <fcom-link class="ms-xsmall-r flex--self-start" (afterNavigation)="linkClick.emit($event)">
    {{ linkText() }}
  </fcom-link>
</ng-template>
